export async function cropImageToSquare(file: File, size = 256): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      reject(new Error("Failed to get canvas context"));
      return;
    }

    img.onload = () => {
      // Set canvas size to desired dimensions
      canvas.width = size;
      canvas.height = size;

      // Calculate the square crop dimensions
      const minDimension = Math.min(img.width, img.height);
      const sourceX = (img.width - minDimension) / 2;
      const sourceY = (img.height - minDimension) / 2;

      // Draw the cropped and resized image
      ctx.drawImage(img, sourceX, sourceY, minDimension, minDimension, 0, 0, size, size);

      // Convert canvas to blob
      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error("Failed to convert canvas to blob"));
          }
        },
        "image/jpeg",
        0.9, // JPEG quality
      );
    };

    img.onerror = () => {
      reject(new Error("Failed to load image"));
    };

    // Create object URL from file
    img.src = URL.createObjectURL(file);
  });
}

// Validate file type and size
export function validateImageFile(file: File): boolean {
  const validTypes = ["image/jpeg", "image/png", "image/webp"];
  const maxSize = 5 * 1024 * 1024; // 5MB

  if (!validTypes.includes(file.type)) {
    throw new Error("Invalid file type. Please upload a JPEG, PNG, or WebP image.");
  }

  if (file.size > maxSize) {
    throw new Error("File is too large. Maximum size is 5MB.");
  }

  return true;
}

// Helper function to combine both operations
export async function processProfileImage(file: File): Promise<Blob> {
  validateImageFile(file);
  const f = await cropImageToSquare(file);
  console.log(f);

  return await cropImageToSquare(file);
}
